import React, { useEffect, useMemo, useRef, useState } from 'react';
import Tooltip from '../../../../../components/Tooltip/Tooltip';
import styles from './ContentWithTooltip.module.scss';
import cx from 'classnames';

const ContentWithTooltip = ({ className, text }) => {
  const containerRef = useRef();
  const spanRef = useRef();
  const [isHover, setIsHover] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    setIsOverflow(spanRef.current?.scrollWidth > spanRef.current?.offsetWidth);
  }, [spanRef.current]);

  return (
    <div
      ref={containerRef}
      className={cx(styles.container, className)}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <span ref={spanRef} className={styles.text}>
        {text ? text : '-'}
      </span>
      <Tooltip text={text} isHover={isOverflow && isHover} classNameTooltip={styles.tooltip} classNameText={styles.tooltipText} />
    </div>
  );
};

export default ContentWithTooltip;
